import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {

  @Input() public content:any; 

  @Output() public callback:EventEmitter<string> = new EventEmitter;

  public paginate:any;


  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      this.start();
    }
  }

  start(){
    this.paginate.first_item = this.content.from;
    this.paginate.last_item = this.content.to;
    this.paginate.last_page = this.content.last_page;
    this.paginate.per_page = this.content.per_page;
    this.paginate.total_items = this.content.total;
    this.paginate.current_page = this.content.current_page;

    this.paginate.pages = [];
    for(let i = 1; i <= this.paginate.last_page; i++){
      this.paginate.pages.push({
        'number': i,
        'label': i
      });
    }
  }
  
  show(){
    return (this.paginate && this.paginate.last_page > 1);
  }

  goPreviousPage(){
    this.goPage(this.paginate.current_page - 1)
  }

  goNextPage(){
    this.goPage(this.paginate.current_page + 1);
  }

  goPage(page){
    this.callback.emit(page);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/partials/pagination/pagination.component.ts